export const AUTH_TOKEN = 'merchantAccessToken',
  MERCHANT_MID = 'mid',
  PRODUCT = 'product',
  DASHBOARD_PREFERENCE = 'dashboardPreference',
  TEST_AUTH_TOKEN = 'testAccessToken',
  TEST_MERCHANT_MID = 'test_mid',
  MERCHANT_ACCOUNT_UUID = 'merchant_account_uuid',
  TEST_MERCHANT_ACCOUNT_UUID = 'test_merchant_account_uuid',
  PRODUCT_ACCOUNT_UUID = 'product_account_uuid',
  TEST_PRODUCT_ACCOUNT_UUID = 'test_product_account_uuid'
  ;
